import { render } from "./sort.vue?vue&type=template&id=3a6cae06&scoped=true"
import script from "./sort.vue?vue&type=script&lang=js"
export * from "./sort.vue?vue&type=script&lang=js"

import "./sort.vue?vue&type=style&index=0&id=3a6cae06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6cae06"]])

export default __exports__